export default class FormatData {
    units = "us";

    constructor(units = "us"){
        this.units = units;
    }

    setUnits(val){
        if( val == "metric" || val == "us" ) this.units = val;
    }
    
    outTemp(value){
        if( value == undefined || value <= -990)
            return "-";
        if( this.units == "metric" )
            return Math.round(value);
        else
            return Math.round(value*9/5+32);
    }
    outTempUnits(){
        if( this.units == "metric" )
            return "C";
        else
            return "F";
    }
    outVisib(value){
        if( value == undefined || value <= -990)
            return "-";
        if( this.units == "metric" ){
            if( value == "10+" )
                return "16+";
            if( value == "6+" )
                return "10+";
            if( value == 10.00 )
                return "16+";
            if( value == 6.21 )
                return "10+";
            value = 1.6*value;
            if( value < 3 )
                return value.toFixed(1);
            else
                return value.toFixed(0);
        }
        else {
            if( value == 10.00 )
                return "10+";
            if( value == 6.21 )
                return "6+";
            if( typeof value == "string")
                return value;
            if( value < 3 )
                return value.toFixed(1);
            else
                return value.toFixed(0);
        }
    }
    outVisibUnits(){
        if( this.units == "metric" )
            return "km";
        else
            return "sm";
    }
    outRelHum(t,td){
        if( t == undefined || t <= -990 || td == undefined || td <= -990)
            return "-";
        var e = 6.1078 * Math.exp(17.2693882 * td / (td + 237.3));
        var es = 6.1078 * Math.exp(17.2693882 * t / (t + 237.3));
        var rh = e/es*100;
        return Math.round(rh);
    }
    outAltim(altim){
        if( altim == undefined || altim <= -990)
            return "-";
        if( this.units == "metric" )
            altim = Math.round(altim*10)%1000;
        else
            altim = Math.round(altim*2992/1013.25)%1000;
        altim = altim.toString().padStart(3, "0");
        return altim;
    }
    outAltimUnits(){
        if( this.units == "metric" )
            return "hPa";
        else
            return "inHg";
    }
    outAltimLong(altim){
        if( altim == undefined || altim <= -990)
            return "-";
        if( !this.units == "metric" )
            altim = Math.round(altim*2992/1013.25)/100;
        return altim;
    }
}
